
import { createRouter, createWebHashHistory,createWebHistory  } from "vue-router"
import { startLoading, loadComplete, Err401 } from '@/utils/util'
import { checkToken, Session } from '@/utils/AxiosToken'

/** 常驻路由 */
export const constantRoutes = [{
    path: "/",
    name: "home",
    component: () => import("@/views/index/index.vue"),
}, {
    path: '/mainpage',
    component: () => import("@/views/mainpage/index.vue"),
},
{
    path: '/pendingorders/:ishistory?',
    name: 'pendingorders',
    component: () => import("@/views/pendingorders/index.vue"),
},
{
    path: '/trackorders/:ishistory?/:dt?',
    name: 'trackorders',
    component: () => import("@/views/pendingorders/trackMyOrder.vue"),
},
{
    path: '/selectproduct',
    name: 'selectproduct',
    component: () => import("@/views/pendingorders/selectProduct.vue"),
},
{
    path: '/checkout/:orderid/:sos',
    name: "checkout",
    component: () => import("@/views/pendingorders/Checkoutpost.vue"),
},
{
    path: '/orderinfo/:orderid/:orderno?',
    name: "orderinfo",
    component: () => import("@/views/orderinfo/index.vue"),
    // beforeEnter: (to, from, next) => {
     
    //     if (to.meta.refreshOrders) {
        
    //       getModel().then((data) => {
           
    //         to.meta.orders = data;
    //         next();
    //       }).catch((error) => {
           
    //         console.error(error);
    //         next();
    //       });
    //     } else {
    //       next();
    //     }
    //   }
},
{
    path: '/addneworder/:producttype/:lastactioncode/:orderid?',

    name: "addneworder",
    component: () => import("@/views/orderinfo/addOrderHdr.vue"),
},
{
    path: '/editorder/:lastactioncode/:orderid?/:orderno?',
    name: "editorderhdr",
    component: () => import("@/views/orderinfo/editOrderHdr.vue"),
},
{
    path: '/shutters/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: 'shutters',
    meta: { orderpage: true },
    component: () => import("@/views/shutters/index.vue"),
    },
    {
        path: '/shuttershandSample/:producttype/:lastactioncode/:orderid?/:handsamplecode?/:line_no?/:orderno?',
        name: "shuttershandSample",
        meta: { orderpage: true },
        component: () => import("@/views/shutters/handSample.vue"),
    },
    {
        path: '/shutters/printDraw/:po?/:line_no?/:img?',
        name: 'printDraw',
        meta: { orderpage: true },
        component: () => import("@/views/shutters/components/printDraw.vue")
      },

    {
        path: '/displaytower/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
        name: "displaytower",
        meta: { orderpage: true },
        component: () => import("@/views/displaytower/index.vue"),
    },
    {
        path: '/shutterPart/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
        name: "shutterPart",
        meta: { orderpage: true },
        component: () => import("@/views/shutters/part.vue"),
    },
{
    path: '/honeycomb/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "honeycomb",
    meta: { orderpage: true },
    component: () => import("@/views/honeycomb_shades/index.vue"),
},
{
    path: '/honeycombPart/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "honeycombPart",
    meta: { orderpage: true },
    component: () => import("@/views/honeycomb_shades/part.vue"),
},
{
    path: '/honeycombhandSample/:producttype/:lastactioncode/:orderid?/:handsamplecode?/:line_no?/:orderno?',
    name: "honeycombhandSample",
    meta: { orderpage: true },
    component: () => import("@/views/honeycomb_shades/handSample.vue"),
},
{
    path: '/blinds/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "blinds", 
    meta: { orderpage: true },
    component: () => import("@/views/blinds/index.vue"),
},

{
    path: '/blindsPart/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "blindsPart",
    meta: { orderpage: true },
    component: () => import("@/views/blinds/part.vue"),
},
{
    path: '/blindshandSample/:producttype/:lastactioncode/:orderid?/:handsamplecode?/:line_no?/:orderno?',
    name: "blindshandSample",
    meta: { orderpage: true },
    component: () => import("@/views/blinds/handSample.vue"),  
},
{
    path: '/smartdrape/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "smartdrape",
    meta: { orderpage: true },
    component: () => import("@/views/smartdrape/index.vue"),
},
{
    path: '/roman/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "roman",
    meta: { orderpage: true },
    component: () => import("@/views/roman/index.vue"),
},
{
    path: '/smartdrapPart/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "smartdrapPart",
    meta: { orderpage: true },
    component: () => import("@/views/smartdrape/part.vue"),
},
{
    path: '/dagger',
    name: 'dagger',
    component: () => import("@/views/daggertest/index.vue"),
},
{
    path: '/questionlist/:dt?',
    name: 'questionlist',
    component: () => import("@/views/QandA/QuestionList.vue"),
},
{
    path: '/questioneditwithout/:orderno',
    name: 'questioneditwithout',
    component: () => import("@/views/QandA/QuestionEditWithOut.vue"),
},
{
    path: '/questionedit/:orderno',
    name: 'questionedit',
    component: () => import("@/views/QandA/QuestionEdit.vue"),
},

{
    path: '/perfectsheer/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "perfectsheer",
    meta: { orderpage: true },
    component: () => import("@/views/perfectsheer_shades/index.vue"),
},
{
    path: '/perfectsheerhandSample/:producttype/:lastactioncode/:orderid?/:handsamplecode?/:line_no?/:orderno?',
    name: "perfectsheerhandSample",
    meta: { orderpage: true },
    component: () => import("@/views/perfectsheer_shades/handSample.vue"),
},
{
    path: '/soluna/:producttype/:lastactioncode/:orderid?/:line_no?/:orderno?',
    name: "soluna",
    meta: { orderpage: true },
    component: () => import("@/views/soluna_shades/index.vue"),
},

{
    path: '/solunahandSample/:producttype/:lastactioncode/:orderid?/:handsamplecode?/:line_no?/:orderno?',
    name: "solunahandSample",
    meta: { orderpage: true },
    component: () => import("@/views/soluna_shades/handSample.vue"),
},
{
    path: '/print/:orderid/:orderno?/:sp?/:changelog?',
    name: "print",
    component: () => import("@/views/print/index.vue"),
},
    {
        path: '/userlist/:requestUserType?',
        name: 'userlist',
        component: () => import("@/views/Users/UserList.vue"),
    }  ,
    {
        path: '/useredit/:userid?',
        name: 'useredit',
        component: () => import("@/views/Users/UserEdit.vue"),
    },
    {
        path: '/usertest',
        name: 'usertest',
        component: () => import("@/views/Users/test.vue"),
    },
    {
        path: '/approveaccount/:userid/:action?',
        name: 'approveaccount',
        component: () => import("@/views/Users/ApproveRegAccount.vue"),
    },
    {
        path: '/changepassword/:havetochange?',
        name: 'changepassword',
        component: () => import("@/views/Users/ChangePwd.vue"),
    },
    {
        path: '/dealerlist',
        name: 'dealerlist',
        component: () => import("@/views/Users/Dealer.vue"),
    } ,
    {
        path: '/dealeredit/:custid?/:action',
        name: 'dealeredit',
        component: () => import("@/views/Users/DealerEdit.vue"),
    },
    {
        path: '/invoice',
        name: 'invoice',
        component: () => import("@/views/Users/InvoiceCompare.vue"),
    },
    {
        path: '/report',
        name: 'report',
        component: () => import("@/views/report/index.vue"),
    },
    {
        path: '/oh_qlist/:requestyype?/:ishistory?',
        name: 'oh_qlist',
        component: () => import("@/views/onhold_question/OHOrderTrack.vue"),
    },
    {
        path: '/oh_questionedit/:WO/:tp?',
        name: 'oh_questionedit',
        component: () => import("@/views/onhold_question/OHOrderList.vue"),
    },
    {
        path: '/oh_questionprint',
        name: 'oh_questionprint',
        component: () => import("@/views/onhold_question/PrintQuestion.vue"),
    },
    {
        path: '/oh_allquestionprint',
        name: 'oh_allquestionprint',
        component: () => import("@/views/onhold_question/PrintAllQuestion.vue"),
    },
    {
        path: '/rga',
        name: "rga",
        component: () => import("@/views/rga/index.vue"),
    }, {
        path: '/rga/request/:type/:qtno',
        name: "request",
        component: () => import("@/views/rga/request.vue"),
    }, {
        path: '/rga/rgadetails/:rgatype/:type/:qtno',
        name: "rgadetails",
        component: () => import("@/views/rga/rgadetails.vue"),
    }, {
        path: '/rga/rgatrack/:ishistory?',
        name: "rgatrack",
        component: () => import("@/views/rga/rgatrack.vue"),
    }, {
        path: '/rga/print/:qtno',
        name: "rgaprint",
        component: () => import("@/views/rga/print.vue"),
    }, {
        path: '/rga/printtrack',
        name: "printtrack",
        component: () => import("@/views/rga/printtrack.vue"),
    },

    {
        path: '/aboutSales',
        name: 'aboutSales',
        component: () => import("@/views/about_sales/sales_information/index.vue"),
    },
    // {
    //     path: '/aboutSales/:type?',
    //     name: 'aboutSales',
    //     component: () => import("@/views/about_sales/sales_information/index.vue"),
    // },
    {
        path: '/aboutSales/customColour',
        name: 'customColour',
        component: () => import("@/views/about_sales/sales_information/customColour.vue"),
    },
    {
        path: '/aboutSales/FAQ',
        name: 'FAQ',
        component: () => import("@/views/about_sales/sales_information/FAQ.vue"),
    },
    {
        path: '/aboutSales/maintenance_Cleaning',
        name: 'maintenance_Cleaning',
        component: () => import("@/views/about_sales/sales_information/maintenance_Cleaning.vue"),
    },
    {
        path: '/aboutSales/newsLetter/:NewsLetterType',
        name: 'NewsLetterType',
        component: () => import("@/views/about_sales/sales_information/newsLetter.vue"),
    },
    {
        path: '/aboutSales/newsLetter',
        name: 'newsLetter',
        component: () => import("@/views/about_sales/sales_information/newsLetterType.vue"),
    },
    {
        path: '/aboutSales/Product',
        name: 'Product',
        component: () => import("@/views/about_sales/sales_information/Product.vue"),
    },
    {
        path: '/aboutSales/priceLists',
        name: "priceLists",
        component: () => import("@/views/about_sales/sales_information/priceLists.vue"),
    },
    {
        path: '/aboutSales/programSpec',
        name: "programSpec",
        component: () => import("@/views/about_sales/sales_information/programSpec.vue"),
    },
    {
        path: '/aboutSales/ShutterBinList',
        name: "ShutterBinList",
        component: () => import("@/views/about_sales/sales_information/component/ShutterBinList.vue"),
    },
    {
        path: '/aboutSales/RomanBinList',
        name: "RomanBinList",
        component: () => import("@/views/about_sales/sales_information/component/RomanBinList.vue"),
    },
    {
        path: '/aboutSales/BFWoodBinList',
        name: "BFWoodBinList",
        component: () => import("@/views/about_sales/sales_information/component/BFWoodBinList.vue"),
    },
    {
        path: '/aboutSales/HoneycombBinList',
        name: "HoneycombBinList",
        component: () => import("@/views/about_sales/sales_information/component/HoneycombBinList.vue"),
    },
    {
        path: '/aboutSales/SolunaBinList',
        name: "SolunaBinList",
        component: () => import("@/views/about_sales/sales_information/component/SolunaBinList.vue"),
    },
    {
        path: '/aboutSales/PerfectsheerBinList',
        name: "PerfectsheerBinList",
        component: () => import("@/views/about_sales/sales_information/component/PerfectsheerBinList.vue"),
    },
    {
        path: '/aboutSales/SmartDrapeBinList',
        name: "SmartDrapeBinList",
        component: () => import("@/views/about_sales/sales_information/component/SmartDrapeBinList.vue"),
    },
    {
        path: '/aboutSales/rgaGuide',
        name: "rgaGuide",
        component: () => import("@/views/about_sales/sales_information/rgaGuide.vue"),
    }, {
        path: '/aboutSales/shutterProcedure',
        name: "shutterProcedure",
        component: () => import("@/views/about_sales/sales_information/shutterProcedure.vue"),
    },
    {
        path: '/aboutSales/privacyPolicy',
        name: "privacyPolicy",
        component: () => import("@/views/about_sales/sales_information/trade_privacyPolicy.vue"),
    },
    {
        path: '/aboutSales/marketing/:orderby?/:type1?/:type2?',
        name: "marketing",
        component: () => import("@/views/about_sales/marketing/index.vue"),
    },
    {
        path: '/editorder/:lastactioncode/:orderid?/:orderno?',
        name: "editorderhdr",
        component: () => import("@/views/orderinfo/editOrderHdr.vue"),
    },
    {
        path: '/product/:orderid?/:orderno?',
        name: "product",
        component: () => import("@/views/orderinfo/selProduct.vue"),
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import("@/views/Users/Setting.vue"),
    } ,
    {
        path: '/banner',
        name: 'banner',
        component: () => import("@/views/Users/Banner.vue"),
    } ,
    {
        path: '/imageedit/:filename?',
        name: 'imageedit',
        component: () => import("@/views/Users/ImageEdit.vue"),
    },
    {
        path: '/resetpwd/:token/:email',
        name: 'resetpwd',
        component: () => import("@/views/Users/ResetPwd.vue"),
    },
    {
        path: '/mainpagecfg',
        name: 'mainpagecfg',
        component: () => import("@/views/mainpage/setting.vue"),
    } ,

]
const whiteList = ['home']
const router = createRouter({
    history: createWebHashHistory(process.env.NODE_ENV === "production" ? "/NormanAustralia/" : "/"),
    routes: constantRoutes
})

//router.beforeEach(async (to, from, next) => {
//    //if (to.name !== 'home' && !isAuthenticated) next({ name: 'Login' })
//    //else next()
//    //console.log("beforeEach", to)
//    startLoading();
//    if (whiteList.indexOf(to.name) == -1) {
//        if (checkToken()) {
//            next();
//            return;
//        } else {
//            Err401();
//            return;
//        }
//    }
//    next()
//})
router.beforeEach(async (to, from, next) => {

    startLoading();
    //const token = Session.get('token');
    //if (to.path === '/login' && !token) {
    //    next();
       
    //} else {
    //    if (!token) {
    //        next(`/login?redirect=${to.path}&params=${JSON.stringify(to.query ? to.query : to.params)}`);
    //        Session.clear();
    //    }
    //    next()
    //}
    next()
})
router.afterEach((to, from, failure) => {
    //console.log("afterEach", to)
    loadComplete();
    //if (!failure) sendToAnalytics(to.fullPath)
})
export default router